import React, { useMemo } from 'react';
import { sum } from 'lodash';
import { rectSortingStrategy, SortableContext } from '@dnd-kit/sortable';
import { useDroppable } from '@dnd-kit/core';

import LeadCard from './LeadCard';

import { formatPrice } from '../../utils/utils';

const PipelineStage = (props) => {
  const {
    stage,
    leads = [],
    surgeons = [],
    labels = [],
    onLeadClick,
    tenantColor,
    surgeonRanking,
    isLast,
  } = props;

  const { setNodeRef } = useDroppable({
    id: stage.id,
  });

  const totalValue = useMemo(() => (
    stage.probability ? (
      sum(leads.map((l) => l.anticipatedValue || 0)) * (stage.probability / 100) || 0
    ) : 0
  ), [stage, leads]);

  const surgeonsNumber = useMemo(() => {
    const arr = [];
    leads.forEach((l) => {
      if (!arr.includes(l.surgeon)) {
        arr.push(l.surgeon)
      }
    });
    return arr.length;
  }, [leads]);

  return (
    <div className="sales-page__stage-item" ref={setNodeRef} style={isLast ? { marginRight: 0 } : {}}>
      <div className='stage-item-title__container'>
        <div className="font-bold font-size-bg">{stage.title}</div>
        <div className="font-size-sm">{stage.description}</div>
        <div className="m-t-sm secondary">
          {`${totalValue ? `$${formatPrice(totalValue, 0)}` : '$0.00'} / ${surgeonsNumber} Surgeon(s)`}
        </div>
      </div>

      <div className='stage-item__leads-list'>
        <SortableContext
          items={leads.map((lead) => lead.id)}
          strategy={rectSortingStrategy}
        >
          {leads?.map((lead) => (
            <LeadCard
              key={lead.id}
              id={lead.id}
              lead={lead}
              surgeons={surgeons}
              labels={labels}
              onClick={() => onLeadClick(lead)}
              tenantColor={tenantColor}
              rottingPeriod={stage.rottingPeriod}
              surgeonRanking={surgeonRanking}
            />
          ))}
        </SortableContext>
      </div>
    </div>
  )
};

export default PipelineStage;